<template>
  <v-app>
    <v-main>
      <Loader />
      <Snackbar />
      <UpgradeMode v-if="upgradeMode" />
      <router-view v-else />
    </v-main>
  </v-app>
</template>

<style>
.v-application > .v-application--wrap > .container {
  max-width: 100%;
}
.v-application ul.v-breadcrumbs {
  margin: 0;
  padding: 0;
}
.v-data-table .v-data-footer__select {
  display: none;
}
.v-data-table .v-data-footer {
  min-height: 50px;
}
.v-data-table tr {
  cursor: pointer;
}
.v-data-table td.v-data-table__mobile-row {
  height: auto;
}

.v-data-table__mobile-row__wrapper {
  padding: 4px 0;
}

.toolbar-action .v-toolbar__content {
  padding-left: 0;
  margin-left: 0;
}

.v-main__wrap .container {
  max-width: none;
}
.base-link {
  border: 4px solid transparent;
  padding: 4px solid transparent;
}
.subgroup-link {
  font-weight: 600;
  padding: 2px 4px;
  text-decoration: none;
}

.fixed-action-bar--open {
  padding-left: 320px !important;
}
.fixed-action-bar {
  border-top: 1px solid #eee;
  background-color: white;
  width: 100%;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  padding: 10px 20px;
  z-index: 100;
}
</style>

<script>
import Loader from '@/views/Loader';
import Snackbar from '@/views/Snackbar';
import UpgradeMode from '@/views/UpgradeMode';
import { extend } from 'vee-validate';
import { required_if } from 'vee-validate/dist/rules';

// Custom vee-validate rules
extend('required_if_not', {
  ...required_if,
  // params: ['target']
  validate: (value, args) => {
    let target_value = args.target;
    return Boolean(target_value || value);
  },
  message: 'Bitte dieses Feld ausfüllen.'
});

export default {
  name: 'App',
  components: {
    Loader,
    Snackbar,
    UpgradeMode
  },
  computed: {
    upgradeMode() {
      return process.env.VUE_APP_UPGRADE_MODE === 'true';
    }
  }
};
</script>
